import React from 'react'
import compose from 'recompose/compose'
import { connect as connectRedux } from 'react-redux'
import { Map } from 'immutable'
import { connect as connectStaticText } from '../../StaticText/connect'
import Button, { TYPES } from '../../Button/index'
import { ADYEN_PAYMENT_TYPE_PAYPAL } from '../../../services/adyen/index'

export const MODE = {
  DARK: 'dark',
  LIGHT: 'light',
}

function getFormattedPaymentType (paymentType) {
  const formattedPaymentType = paymentType.replace(/\s+/g, '').toLowerCase()
  if (formattedPaymentType === 'creditcard') {
    return null
  }
  return formattedPaymentType
}

function formatCardNumber (paymentSource) {
  const paymentType = paymentSource.get('type')
  const maskedCardNumber = paymentSource.get('maskedCardNumber') || '••••'
  const cardFiller = paymentType === ADYEN_PAYMENT_TYPE_PAYPAL ? '•••• ' : '•••• •••• •••• '
  return `${cardFiller}${maskedCardNumber.slice(-4)}`
}

/**
 * Component to handle the payment info
 * @param {Map} props.staticText - Static text translations
 * @param {Map} props.userAccount - User account state
 * @param {Function} props.onChangePaymentClick - Function to change payment
 * @param {String} props.mode - Mode
 * @returns {React.ReactNode}
 */
function CartSinglePagePaymentInfo (props) {
  const {
    staticText,
    userAccount = Map(),
    onChangePaymentClick,
    mode,
    user,
  } = props
  const paymentSource = userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'paymentSource']) || Map()
  const paymentType = getFormattedPaymentType(paymentSource.get('type') || '')
  const paymentCardType = paymentSource.get('cardType') || ''
  const cardType = paymentCardType.replace(/\s+/g, '').toLowerCase()
  const firstName = user.getIn(['data', 'firstName'])
  const userName = firstName ? `${firstName} ${user.getIn(['data', 'lastName'])}` : user.getIn(['data', 'name'])
  const cardNumber = formatCardNumber(paymentSource)

  return (
    <div className={`cart-single-page__payment-info cart-single-page__payment-info--${mode}`}>
      <div className="cart-single-page__payment-info-label">
        {`${staticText.getIn(['data', 'previousPaymentInfo'])}${onChangePaymentClick ? '' : ':'}`}
      </div>
      {onChangePaymentClick && (
        <Button
          type={TYPES.LINK}
          className="cart-single-page__payment-info-button"
          onClick={onChangePaymentClick}
        >
          {staticText.getIn(['data', 'change'])}
        </Button>
      )}
      <div className="cart-single-page__payment-info-method">
      {paymentType && (
        <div className={`cart-single-page__payment-info-method-logo cart-single-page__payment-info-method-logo--${paymentType}`} />
      )}
      {
        paymentType && paymentCardType && <div className="cart-single-page__payment-info-method-division"></div>
      }
      {paymentCardType
        ? <div className="cart-single-page__payment-info-method-card">
            <div className={`cart-single-page__payment-info-method-card-logo cart-single-page__payment-info-method-card-logo--${cardType}`} />
            <div className="cart-single-page__payment-info-method-card-info">{cardNumber}</div>
          </div>
        : <div className="cart-single-page__payment-info-method-user-name">
            {userName}
          </div>
      }
    </div>
  </div>
  )
}

CartSinglePagePaymentInfo.defaultProps = {
  mode: MODE.DARK,
}

export default compose(
  connectStaticText({ storeKey: 'CartSinglePage' }),
  connectRedux(
    (state) => ({
      userAccount: state.userAccount,
      user: state.user,
    }),
  ),
)(CartSinglePagePaymentInfo)
